import React from "react";
import { Link } from "react-router-dom";

interface EditButtonProps {
  to?: string;
  onClick?: () => void;
  className?: string;
  iconClassName?: string;
  isLoading?: boolean;
  children?: React.ReactNode;
  title?: string;
}

const EditButton: React.FC<EditButtonProps> = ({
  to,
  onClick,
  className = "",
  iconClassName = "ph-pencil",
  isLoading = false,
  children,
  title = "Edit",
}) => {
  const buttonStyle = {
    borderRadius: "6px",
    padding: "6px 10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#28a745",
    borderColor: "#218838",
    color: "#fff",
    transition: "all 0.2s ease",
    textDecoration: "none",
    width: "32px",
    height: "32px",
    cursor: "pointer",
    border: "1px solid #218838",
  };

  const handleMouseEnter = (e: React.MouseEvent<HTMLElement>) => {
    e.currentTarget.style.backgroundColor = "#218838";
    e.currentTarget.style.transform = "translateY(-1px)";
    e.currentTarget.style.boxShadow = "0 2px 4px rgba(40, 167, 69, 0.3)";
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLElement>) => {
    e.currentTarget.style.backgroundColor = "#28a745";
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "none";
  };

  if (onClick) {
    return (
      <span
        onClick={onClick}
        className={`btn btn-sm ${className}`}
        style={buttonStyle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        title={title}
      >
        {isLoading && children ? children : <i className={iconClassName} style={{ fontSize: "14px" }}></i>}
      </span>
    );
  }

  return (
    <Link
      to={to || "#"}
      className={`btn btn-sm ${className}`}
      style={buttonStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      title={title}
    >
      {isLoading && children ? children : <i className={iconClassName} style={{ fontSize: "14px" }}></i>}
    </Link>
  );
};

export default EditButton;
